import { render } from "./SalespersonList.vue?vue&type=template&id=633dd351&scoped=true&ts=true"
import script from "./SalespersonList.vue?vue&type=script&lang=ts"
export * from "./SalespersonList.vue?vue&type=script&lang=ts"

import "./SalespersonList.vue?vue&type=style&index=0&id=633dd351&scoped=true&lang=css"

import exportComponent from "/Users/david/Documents/repos/fancypools-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-633dd351"]])

export default __exports__